import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_2 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_3 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_4 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_5 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_6 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_7 = { class: "d-flex flex-column align-items-start w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvatarUploader = _resolveComponent("AvatarUploader")!
  const _component_DivCol = _resolveComponent("DivCol")!
  const _component_DivRow = _resolveComponent("DivRow")!
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_PageContentSection = _resolveComponent("PageContentSection")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_PageContentBase, { plain: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_PageContentSection, { "always-expanded": true }, {
        header: _withCtx(() => [
          _createTextVNode("Cập nhật hồ sơ")
        ]),
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createElementBlock("div", null, [
            _createVNode(_component_el_form, {
              ref: "formRef",
              model: _ctx.form,
              rules: _ctx.rules,
              onSubmit: _withModifiers(_ctx.submit, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DivRow, { class: "mb-4 g-3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DivCol, { cols: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_AvatarUploader, {
                          modelValue: _ctx.avatarUrl,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.avatarUrl) = $event)),
                          alt: _ctx.form.ho_va_ten || 'Ảnh đại diện',
                          onUploaded: _ctx.onAvatarUploaded
                        }, null, 8, ["modelValue", "alt", "onUploaded"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivRow, { class: "mb-3 g-3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DivCol, {
                      "additional-class": "pb-4",
                      cols: 4
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          _createVNode(_component_LabelCustom, { "is-required": "" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Họ và tên")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            prop: "ho_va_ten",
                            class: "mb-0 w-100"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.form.ho_va_ten,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.ho_va_ten) = $event)),
                                placeholder: "Nhập họ và tên",
                                name: "ho_va_ten",
                                maxlength: "255",
                                "show-word-limit": ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DivCol, {
                      "additional-class": "pb-4",
                      cols: 4
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_LabelCustom, { "is-required": "" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Số điện thoại")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            prop: "so_dien_thoai",
                            class: "mb-0 w-100"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.form.so_dien_thoai,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.so_dien_thoai) = $event)),
                                placeholder: "Nhập số điện thoại",
                                name: "so_dien_thoai",
                                maxlength: "15",
                                "show-word-limit": ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DivCol, {
                      "additional-class": "pb-4",
                      cols: 4
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_LabelCustom, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Email")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            prop: "email",
                            class: "mb-0 w-100"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.form.email,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.email) = $event)),
                                placeholder: "Nhập email",
                                name: "email"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivRow, { class: "mb-4 g-3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DivCol, {
                      "additional-class": "pb-2",
                      cols: 4
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_LabelCustom, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Tên đăng nhập")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_input, {
                            "model-value": _ctx.username || '—',
                            disabled: ""
                          }, null, 8, ["model-value"])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DivCol, {
                      "additional-class": "pb-2",
                      cols: 4
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_LabelCustom, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Đơn vị")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_input, {
                            "model-value": _ctx.departmentName,
                            disabled: ""
                          }, null, 8, ["model-value"])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DivCol, {
                      "additional-class": "pb-2",
                      cols: 4
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_LabelCustom, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Bộ phận")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            prop: "id_bo_phan",
                            class: "mb-0 w-100"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.form.id_bo_phan,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.id_bo_phan) = $event)),
                                class: "w-100",
                                placeholder: "Chọn bộ phận",
                                filterable: "",
                                clearable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boPhanOptions, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.ten_bo_phan,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DivCol, {
                      "additional-class": "pb-2",
                      cols: 4
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_LabelCustom, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Chức vụ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            prop: "id_chuc_vu",
                            class: "mb-0 w-100"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.form.id_chuc_vu,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.id_chuc_vu) = $event)),
                                class: "w-100",
                                placeholder: "Chọn chức vụ",
                                filterable: "",
                                clearable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chucVuOptions, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.ten_chuc_vu,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivRow, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_DivCol, {
                      cols: 12,
                      "additional-class": "d-flex justify-content-center gap-x-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ButtonCustom, {
                          "button-type": _ctx.ButtonsType.SAVE,
                          "color-type": _ctx.ButtonTypeColors.SUCCESS,
                          disabled: _ctx.isLoading || _ctx.pageLoading,
                          "is-loading": _ctx.isLoading,
                          onClick: _ctx.submit
                        }, {
                          "button-label": _withCtx(() => [
                            _createTextVNode("Lưu")
                          ]),
                          _: 1
                        }, 8, ["button-type", "color-type", "disabled", "is-loading", "onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules", "onSubmit"])
          ])), [
            [_directive_loading, _ctx.pageLoading]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}